var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { View, Text, Document, Page, } from "@react-pdf/renderer";
import { createContext, useContext } from "react";
import { View as BrowserView, Text as BrowserText, Document as BrowserDocument, Page as BrowserPage } from './components.browser';
const PDFContext = createContext({
    View,
    Text,
    Document,
    Page
});
export const usePDFContext = () => useContext(PDFContext);
export function PDFContextProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(PDFContext.Provider, { value: props, children: children }));
}
export function PDFPreview({ children }) {
    return (_jsx(PDFContextProvider, { View: BrowserView, Text: BrowserText, Document: BrowserDocument, Page: BrowserPage, children: children }));
}
export function PDFRender({ children }) {
    return (_jsx(PDFContextProvider, { View: View, Text: Text, Document: Document, Page: Page, children: children }));
}
